import React, {useState, useRef, useEffect} from 'react';
import { Route, Routes, useLocation, useNavigate, useSearchParams} from 'react-router-dom' 
import { Audio } from 'react-loader-spinner'
//import { ThreeCircles } from 'react-loader-spinner'

import routes from '../client/routes/routes.js'

//import fetch from 'isomorphic-fetch';

import Breadcrumbs from '../client/legacy/components/breadcrumbs.js'
import ErrorBoundary from '../client/legacy/components/errorBoundary.js'
import PageHeader from '../client/legacy/components/header.js'
import Footer from '../client/legacy/components/footer.js'
import MainHelmet from '../client/legacy/components/mainHelmet.js'
import PageHelmet from '../client/legacy/components/pageHelmet.js'
import ErrorMessage from '../client/legacy/components/errorMessage.js'

import Login from '../client/legacy/pages/Login/index.js'
import ResetPassword from '../client/legacy/pages/ResetPassword/index.js'
import Register from '../client/legacy/pages/Register/index.js'

import AuthUserProvider, {useAuth} from '../client/legacy/helpers/authContext.js'
import LoginProvider, {useLogin} from '../client/legacy/helpers/loginContext.js'

import Turnstile, { useTurnstile } from "react-turnstile";
import { APIResponse } from '../server/routes/route-types.js';
import * as Utils from '../server/src/utils.js'

// Extend Window interface for global variables
declare global {
 	const __isBrowserContext__: boolean;
 	function wtsDelayLoadImanges(): void;
}

// Interface for page data
interface PageData {
	User?: {
		LoggedIn: boolean;
	};
	err?: string;
	results?: wts_approved_any;
	result301?: string;
	result302?: string;
	resultLoginRequired?: boolean;
	requireCaptchaCheck?: boolean;
}

// Interface for route configuration (matching client/routes/routes.js)
interface RouteConfig {
	path: string;
	exact: boolean;
	component: React.ComponentType<wts_approved_any>;
	pageTitle: string;
	pageDescription: string;
	loadServerData: boolean;
	noSSR?: boolean;
	addZeroPage?: boolean;
	page404?: boolean;
}

// Interface for component props
interface AppProps {
	pageData?: PageData | null;
}

interface RouteWrapperProps {
	route: RouteConfig;
	component: React.ComponentType<wts_approved_any>;
	fetchData: boolean;
	addZeroPage?: boolean;
	pageData?: PageData | null;
	path: string;
}

interface RealRouteProps {
	C: React.ComponentType<wts_approved_any>;
	fetchData: boolean;
	props: PageData | null;
}

interface LoadingRouteProps {
	C?: React.ComponentType<wts_approved_any>;
	props?: wts_approved_any;
}

export default function App ({ pageData=null }: AppProps) {

  let [data, setData] = useState<PageData | null>(() => {

    if (__isBrowserContext__) {
      if (window && window.__WTS_SSR_DATA__) {
          return window.__WTS_SSR_DATA__.pageData;
        }
      else {
        return null;
      }
    }
    else {
      return pageData;
    }
  });

  let user: boolean = false;
  if (data && data.User) {
    user = data.User.LoggedIn;
  }

  return (
    <>
      <AuthUserProvider user={user}>
        <LoginProvider>
          <MainHelmet />
            <PageHeader props={data} />
            <Routes>
            {routes.map((route: RouteConfig) => {
              const {
                path,
                loadServerData,
                addZeroPage,
                component: C,
                pageTitle,
                pageDescription
              } = route;

              return (
                <Route
                  key={path}
                  path={path}
                  element={
                      <RouteWrapper
                        key={path}
                        path={path}
                        route={route}
                        component={C}
                        fetchData={loadServerData}
                        addZeroPage={addZeroPage}
                        pageData={pageData}
                      />
                  } 
                />
              )
            })}
          </Routes>
        <Footer props={data} />
      </LoginProvider>
    </AuthUserProvider>
  </>
  )
}

function CaptchaControl(){

  const turnstile = useTurnstile();

  async function onVerified(token: string): Promise<void> {

    console.log(`Challenge Success ${token}`);
    try
    {
      const response = await fetch('/validate-captcha', {
          body: JSON.stringify({
              token
          }),
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          }
      });
      const jsonResponse: APIResponse<{}> = await response.json();
      if (!jsonResponse.err) {
        window.location.reload();
      }
      else {
        console.log(`Error validation captcha on the server`);
        turnstile.reset();
      }
    }
    catch (err) {
      console.log(`Error validating captcha`);
      turnstile.reset();
    }
  }

  return (
    <>
    <Turnstile
      sitekey="0x4AAAAAABcxxPZ1PvjrqjsS"
      onVerify={onVerified}
    />
    Please wait while we are verifying you. After verification is done the page will be reloaded.
    </>
  );
}

function RouteWrapper({route, component:C, fetchData, addZeroPage, pageData}: RouteWrapperProps) {
  
  const navigate = useNavigate();
  const location = useLocation();
  const {setLoginType} = useLogin();

  const locationPath: string = location.pathname;
  let [searchParams, setSearchParams] = useSearchParams();
  const fullQueryString: string = searchParams.toString();
  
  const {setUser} = useAuth();
  
  //let [locationPath, setLocation] = useState(locationPath);

  let SSRedRoute: boolean = false;
  let [data, setData] = useState<PageData | null>(() => {

    if (__isBrowserContext__) {
      if (window && window.__WTS_SSR_DATA__) {
          SSRedRoute = true;
          return window.__WTS_SSR_DATA__.pageData;
        }
      else {
        console.log(`Creating state with SSR for RouteWrapper: null`)
        return null;
      }
    }
    else {
      return pageData;
    }
  });

  let locationChangeCount = useRef<number>(0);

  useEffect(()=>{

    locationChangeCount.current += 1;
    if (SSRedRoute) {
//      console.log(`SSR-ed root`)
      if (locationChangeCount.current == 1) {
//          console.log(`Ignoring first SSR-ed render`)
          return;
      }
    }

    setData(null);
    reloadPage();

  },[location])

  function reloadPage(): void {

    console.log(`Fetch data in reload page: ${fetchData}`)
    console.log(`'data' in  reload page: ${data}`)
   

    if (!fetchData) return; // server-side rendering 

    const addZeroPageIndex: string = addZeroPage ? '/1' : '';

    let pathAPI: string = (locationPath == '/' ? '' : locationPath) + addZeroPageIndex + '/api';
    if (fullQueryString.length > 0) {
      pathAPI += `?${fullQueryString}`
    }

    fetch(pathAPI)
    .then(response => response.json())
    .then((jsonResponse: PageData) => {
      if (jsonResponse.err) {
        setData(jsonResponse);
      }
      else {
        setData(jsonResponse);
      }
      if (jsonResponse.result301) {
        console.log(`301 redirected to '${jsonResponse.result301}'`)
        navigate(jsonResponse.result301);
      }
      else if (jsonResponse.result302) {
        console.log(`302 redirected to '${jsonResponse.result302}'`)
        navigate(jsonResponse.result302);
      }
      else if (jsonResponse.resultLoginRequired) {
        // jsonResponse.err = null;
        setLoginType((<Login />));
      }
      else if (jsonResponse.requireCaptchaCheck) {
        setLoginType((<CaptchaControl />));
      }
      else {
        setLoginType(null);
      }

      if (jsonResponse.User && jsonResponse.User.LoggedIn) {
        setUser(true);  
      }
      else {
        setUser(false);
      }

      setTimeout(wtsDelayLoadImanges, 1000);

    })
    .catch(( err: unknown ) => {
      console.error(`Exception from '${pathAPI}':`, Utils.getErrorFromUnknown(err));
    });
  }

  const pageComponent = (
    <>
      <RealRoute 
        C={C} 
        fetchData={fetchData}
        props={data}
      />
    </>);

//  console.log(pageComponent); 

  return pageComponent;
}

function RealRoute({C, fetchData, props}: RealRouteProps) {

  const {loginType, setLoginType} = useLogin()

  // when we switch routes we always need to scroll to the top of the page
  useEffect(()=> {
    window.scroll({
      top:0
    })
  })

  useEffect(()=> {
    try {
      if (props) {
        if (props.resultLoginRequired) {
          setLoginType((<Login />));
        }
        else if (props.requireCaptchaCheck) {
          setLoginType((<CaptchaControl />));
        }
      }
    }
    catch (e) {
      // TODO: report error back to the mothership
    }
  }, [])

  if (!props && fetchData) return (
    <div className="container" style={{minHeight:"100vh"}}> 
        <div  
          style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                marginTop: "-300px",
                marginLeft: "-50px",
                width: "100px",
                height: "100px"
            
          }}> 
        <LoadingRoute />
      </div>
    </div>
    )

    
  let actualPage = null;

  if (null != loginType) {
    actualPage = (<ShowLoginDialog />)
  }
  else if (props && props.err) {
    actualPage = (<ErrorMessage message={props.err} />);
  }
  else {
    actualPage = (<C pageData={props ? props.results : null} />)
  }

  // normal case
  return (
    <>
    	<PageHelmet props={props ? props.results : null} />
      <Breadcrumbs props={props ? props.results : null} />
      <div className="container"  style={{minHeight:"60vh"}}>
        <ErrorBoundary>
        {actualPage}
        </ErrorBoundary>
      </div>        
    </>
    )

}

function ShowLoginDialog() {

  const {loginType, setLoginType} = useLogin()

  const closeButtonStyles: React.CSSProperties = {
    "position": "absolute",
    "top": "10px",
    "right": "10px",
    "fontSize": "20px",
    "fontWeight": "bold",
    "color": "#555",
    "cursor": "pointer",
    "border": "none",
    "background": "transparent"
  }

  return (
  <div>
    <div>
      <div className="row mt-5">
        <div className="col-md-5 m-auto">
          <div className="card card-body">
            {
             <button style={closeButtonStyles} onClick={() => {setLoginType(null)}}>&times;</button>
            }
            {loginType}
          </div>
        </div>
      </div>
    </div>
  </div>
  );
}

function LoadingRoute({C, props}: LoadingRouteProps) {

  return (
    <>
    <Audio
      height="80"
      width="80"
      //radius="9"
      color="#16b6d2"
      ariaLabel="loading"
      wrapperStyle={{}}
      wrapperClass=""
    />
    </>
    );
}
